import 'normalize.css';
import 'flexboxgrid2';
import '@/assets/global.scss';
import router from './router'
import Vue from 'vue';
import App from './App.vue';
import SmoothScrolling from '@/utils/SmoothScrolling';
import CoolConsoleLog from '@/utils/CoolConsoleLog';

// Init SmoothScrolling.
window.onload = () => {
  SmoothScrolling.start();

  const ccl = new CoolConsoleLog();
  ccl.pimpIt();
}

// Start VueJS app.
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
